import ar from './ar.json';
import en from './en.json';
import ru from './ru.json';

const storage = {
   getItem: (key) => localStorage.getItem(key),
   setItem: (key, value) => localStorage.setItem(key, value),
};

class I18nService {
   constructor() {
      this.translations = { en, ar, ru };

      this.language = 'en'; // Default, updated in init()
      this.listeners = new Set();
      this.init();
   }

   init() {
      if (typeof window !== 'undefined') {
         const storedLanguage = storage.getItem('language') || 'en';
         this.setLanguage(storedLanguage);
      } else {
         this.setLanguage('en');
      }
   }

   setLanguage(lang) {
      if (!this.translations[lang]) lang = 'en'; // fallback

      this.language = lang;

      if (typeof window !== 'undefined') {
         storage.setItem('language', lang);
         document.documentElement.lang = lang;
         document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';

         if (lang === 'ar') {
            document.body.classList.add('rtl');
            document.body.classList.remove('ltr');
         } else {
            document.body.classList.add('ltr');
            document.body.classList.remove('rtl');
         }
      }

      this.notifyListeners();
   }

   t(path, variables = {}) {
      const keys = path.split('.');
      let result = this.translations[this.language];

      for (const key of keys) {
         if (result && result[key]) {
            result = result[key];
         } else {
            return path; // Fallback to path if not found
         }
      }

      if (typeof result === 'string' && Object.keys(variables).length > 0) {
         Object.entries(variables).forEach(([key, value]) => {
            result = result.replace(new RegExp(`\\{${key}\\}`, 'g'), value);
         });
      }

      return result;
   }

   subscribe(listener) {
      this.listeners.add(listener);
      return () => this.listeners.delete(listener);
   }

   notifyListeners() {
      this.listeners.forEach(listener => listener(this.language));
   }
}

export const i18n = new I18nService();
